// app/javascript/controllers/guests_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactSelect"]

  updateContacts(event) {
    const customerId = event.target.value
    const placeholder = this.contactSelectTarget.options[0]?.textContent || ""

    this.resetContactSelect(placeholder)

    if (!customerId) return

    fetch(`/customers/${customerId}/contacts_for_select`, {
      headers: { Accept: "application/json" }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)

        return response.json()
      })
      .then(data => {
        const contacts = data.contacts || []

        this.resetContactSelect(placeholder)

        contacts.forEach(contact => {
          const option = document.createElement("option")
          option.value = contact.id
          option.textContent = contact.name
          this.contactSelectTarget.appendChild(option)
        })
      })
      .catch(() => this.resetContactSelect(placeholder))
  }

  resetContactSelect(placeholder) {
    this.contactSelectTarget.replaceChildren(new Option(placeholder, ""))
  }
}
